import type { Gtm } from '~~/types/@nuxtjs/gtm';

export const pushCleanTags = ($gtm: Gtm, tags: object) => {

  $gtm.push({ ecommerce: null });
  $gtm.push(tags);

};
